// removed by extract-text-webpack-plugin
module.exports = {"clickToCopyText":"clickToCopyText___gQ3Zj"};